import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Components
import Navbar from '../navbar/Navbar';
import Loader from '../loader/Loader';

// CSS
import '../../css/landing/landing.css';
import '../../css/ecomPages/ecomPages.css';
import Sidebar from '../sidebar/Sidebar';

const FirstCryEcom = ({ auth: { isAuthenticated, user } }) => {
  const [paidButton, setPaidButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // State to manage active library
  const [activeLibrary, setActiveLibrary] = useState('Python');

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();

        // Save the IP address in local storage
        localStorage.setItem('userIp', data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };

    // Check if the user's IP address is already saved in local storage
    const savedUserIp = localStorage.getItem('userIp');
    if (!savedUserIp) {
      fetchIpAddress();
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      setIsLoading(true);
      // console.log('user Authenticated');
      // console.log('user', user);

      if (user.is_paid) {
        // console.log('paid User', user.is_paid);
        setPaidButton(true);
        setIsLoading(false);
      } else {
        // console.log('no is_paid user');
        setIsLoading(false);
      }
    }
  }, [isAuthenticated, user]);

  const explanationStepsPython = [
    {
      title: 'Install pip',
      description: 'Ensure the pip package is installed.',
    },
    {
      title: 'API Endpoint',
      description: 'Set the URL to send requests.',
    },
    {
      title: 'Request Body',
      description: 'Contains the necessary data to interact with the API.',
    },
    {
      title: 'POST Request',
      description:
        'Sends a request with post() Method. Includes Content-Type: application/json in headers.',
    },
    {
      title: 'Error Handling',
      description: 'Gracefully handle any API errors.',
    },
    {
      title: 'Execution',
      description: 'Call the function to get data.',
    },
  ];

  const explanationStepsJS = [
    {
      title: 'Install Axios',
      description: 'Ensure the axios package is installed.',
    },
    {
      title: 'API Endpoint',
      description: 'Set the URL to send requests.',
    },
    {
      title: 'Request Body',
      description: 'Contains the necessary data to interact with the API.',
    },
    {
      title: 'POST Request',
      description:
        'Sends a request with axios.post(). Includes Content-Type: application/json in headers.',
    },
    {
      title: 'Error Handling',
      description: 'Gracefully handle any API errors.',
    },
    {
      title: 'Execution',
      description: 'Call the function to get data.',
    },
  ];

  const explanationStepsCurl = [
    {
      title: 'API Endpoint',
      description: `The API URL is ${process.env.REACT_APP_API_BASE_URL}/ecomnext/api/ecom-firstcry, which receives POST requests..`,
    },
    {
      title: 'Request Header',
      description:
        '-H "Content-Type: application/json" ensures the request body is sent in JSON format.',
    },
    {
      title: 'Request Body',
      description:
        'The -d flag is used to provide JSON data containing: api_key, zipcode, links',
    },
    {
      title: 'POST Request:',
      description: '-X POST specifies the HTTP method as POST.',
    },
    {
      title: 'Execution',
      description:
        'Run the command in the terminal to send the request and receive a response.',
    },
    {
      title: 'Error Handling',
      description:
        'Any errors will be displayed in the terminal if the request fails.',
    },
  ];

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className='flex min-h-screen'>
          {/* Sidebar */}
          <div className='w-64'>
            <Sidebar />
          </div>

          {/* Main Content Area */}
          <div className='flex-1 flex flex-col'>
            {/* Navbar */}
            <div className=''>
              <Navbar />
            </div>

            {/* Main Content */}
            <div className='ecom-pages-content-wrapper flex-1 bg-white'>
              {/* About AMAZON API */}
              <div className='overview-about-ecom-pages-api'>
                {/* Heading */}
                <h2 className='mb-3.5'>Firstcry</h2>

                {/* Subheading */}
                <p className='mb-9'>
                  The Firstcry Scraping API serves as a cutting-edge tool for
                  obtaining immediate product data from Firstcry’s e-commerce
                  platform. It requires two essential inputs:
                </p>

                <h3 className='mb-3.5'>Zip Code</h3>
                <p className='mb-9'>
                  This parameter specifies the particular pincode for which
                  product information is requested. It is vital, as Firstcry's
                  product offerings and availability can vary based on location.
                </p>

                <h3 className='mb-3.5'>List of PIDs</h3>
                <p className='mb-9'>
                  This input comprises a series of Product IDs (PIDs)
                  corresponding to the items intended for extraction. Each PID
                  uniquely identifies a product within Firstcry’s extensive
                  catalog, ensuring accurate data retrieval.
                </p>

                <p className='mb-4'>
                  Upon processing these inputs, the API returns a
                  well-structured response containing crucial details for each
                  product, including pricing, availability, and other relevant
                  characteristics. Designed for efficiency, this API can manage
                  multiple PIDs in a single request, making it ideal for
                  large-scale data extraction. The output provides
                  up-to-the-minute updates on product pricing and stock
                  availability, enabling businesses and consumers to stay
                  informed about Firstcry's dynamic inventory landscape.
                </p>
              </div>

              <div className='max-w-full mx-auto p-8 bg-white shadow-lg rounded-lg'>
                <h1 className='implementation-guide-heading text-3xl mb-6 text-left leading-tight'>
                  How to Implement the First Cry EcomNext API in Your
                  Application
                </h1>

                {/* Step 1 */}
                <div className='border-l-4 border-gray-600 pl-4 mb-6'>
                  <h2 className='step-number-heading mb-2'>
                    Step 1: Choose Library
                  </h2>

                  {/* Library Selection Section */}
                  <div className='flex items-center space-x-4 mt-4'>
                    <p className='ecom-pages-select-library-heading'>
                      Select library
                    </p>

                    <div className='switch-btn-wrapper flex rounded-full overflow-hidden'>
                      {/* Python Button */}
                      <button
                        className={`px-4 py-1 transition ${
                          activeLibrary === 'Python'
                            ? 'library-switch-btn-active'
                            : 'library-switch-btn-inactive'
                        }`}
                        onClick={() => setActiveLibrary('Python')}
                      >
                        Python
                      </button>
                      <div className='w-px switch-btn-partition'></div>

                      {/* Curl Button */}
                      <button
                        className={`px-4 py-1 transition ${
                          activeLibrary === 'Curl'
                            ? 'library-switch-btn-active'
                            : 'library-switch-btn-inactive'
                        }`}
                        onClick={() => setActiveLibrary('Curl')}
                      >
                        Curl
                      </button>
                      <div className='w-px switch-btn-partition'></div>

                      {/* JavaScript Button */}
                      <button
                        className={`px-4 py-1 transition ${
                          activeLibrary === 'JavaScript'
                            ? 'library-switch-btn-active'
                            : 'library-switch-btn-inactive'
                        }`}
                        onClick={() => setActiveLibrary('JavaScript')}
                      >
                        JavaScript
                      </button>
                    </div>
                  </div>

                  {/* Descriptive Text */}
                  {activeLibrary === 'JavaScript' && (
                    <p className='text-lg text-gray-700 mb-6 text-left mt-4'>
                      The following guide will help you integrate the EcomNext
                      API into your JavaScript application.
                      <span className='font-semibold text-blue-500'>
                        {' '}
                        JavaScript (Node.js + Axios)
                      </span>
                      .
                    </p>
                  )}

                  {activeLibrary === 'Python' && (
                    <p className='text-lg text-gray-700 mb-6 text-left mt-4'>
                      The following guide will help you integrate the EcomNext
                      API into your{' '}
                      <span className='font-semibold text-gray-700 bg-gray-100 rounded-md mx-1 px-1'>
                        {' '}
                        Python{' '}
                      </span>{' '}
                      application.
                    </p>
                  )}

                  {activeLibrary === 'Curl' && (
                    <p className='text-lg text-gray-700 mb-6 text-left mt-4'>
                      If you prefer using
                      <span className='font-semibold text-gray-700 bg-gray-100 rounded-md mx-1 px-1'>
                        {' '}
                        cURL{' '}
                      </span>
                      for API requests from the command line, follow the guide
                      below.
                    </p>
                  )}
                </div>

                {/* Step 2 */}
                {activeLibrary === 'JavaScript' && (
                  <div className='border-l-4 border-blue-500 pl-4 mb-6'>
                    <h2 className='step-number-heading mb-2'>
                      Step 2: Install Axios
                    </h2>
                    <p className='text-gray-700 mb-4'>
                      If you haven't already, install the Axios package to make
                      HTTP requests.
                    </p>

                    <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                      <code className='text-green-400'>
                        {`npm install axios`}
                      </code>
                    </pre>
                  </div>
                )}

                {activeLibrary === 'Python' && (
                  <div className='border-l-4 border-blue-500 pl-4 mb-6'>
                    <h2 className='step-number-heading mb-2'>
                      Step 2: Install Requests Library
                    </h2>
                    <p className='text-gray-700 mb-4'>
                      Make sure you have the requests library installed. If not,
                      install it using:
                    </p>

                    <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                      <code className='text-green-400'>
                        {`pip install requests`}
                      </code>
                    </pre>
                  </div>
                )}

                {/* Step 3(Python and JS) and Step 2 (CURL ) */}
                <div className='border-l-4 border-green-500 pl-4'>
                  <h2 className='step-number-heading mb-2'>
                    {activeLibrary === 'Curl'
                      ? 'Step 2: Implementation'
                      : 'Step 3: Implementation'}
                  </h2>

                  <p className='text-gray-700'>
                    Select the appropriate library for your application to
                    interact with the API effectively.
                  </p>

                  {/* Request Method */}
                  <div className='req-method-about-ecom-pages-api mb-9'>
                    {activeLibrary === 'Python' && (
                      <div className='python-request mt-8'>
                        <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                          <code>
                            {`import requests
import json

# Define the API endpoint
API_ENDPOINT = '${process.env.REACT_APP_API_BASE_URL}
/ecomnext/api/ecom-firstcry'

# Request body
request_data = {
    "api_key":"e769294327655e0ca20970dd7dd1b400",
    "key_id":"U2FsdGVkX1+RrnShmu3vfqRQnHa/a1f5SmjyEsSLyfI=",
    "zipcode": "560038",
    "pid": ["3437926"]
}

# Function to fetch API data
def fetch_ecom_data():
    try:
        print("Fetching data, please wait...")

        # Sending POST request
        response = requests.post(API_ENDPOINT, json=request_data,
         headers={'Content-Type': 'application/json'})

        # Check if request was successful
        response.raise_for_status()
        
        # Parse JSON response
        response_data = response.json()
        print("API Response:", json.dumps(response_data, indent=4))
    except requests.exceptions.RequestException as e:
        print("Error fetching data:", e)

# Execute function
fetch_ecom_data()
`}
                          </code>
                        </pre>
                      </div>
                    )}

                    {activeLibrary === 'Curl' && (
                      <div className='curl-request mt-8'>
                        <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                          <code>
                            {`curl -X POST ${process.env.REACT_APP_API_BASE_URL}
                            /ecomnext/api/ecom-firstcry' \

-H "Content-Type: application/json" \

-d '{
    "api_key":"e769294327655e0ca20970dd7dd1b400",
    "key_id":"U2FsdGVkX1+RrnShmu3vfqRQnHa/a1f5SmjyEsSLyfI=",
    "zipcode": "560038",
    "pid": ["3437926"]
}'`}
                          </code>
                        </pre>
                      </div>
                    )}

                    {activeLibrary === 'JavaScript' && (
                      <div className='javascript-request mt-8'>
                        <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                          <code>
                            {`const axios = require('axios');

// Define the API endpoint
const API_ENDPOINT = '${process.env.REACT_APP_API_BASE_URL}
/ecomnext/api/ecom-firstcry';

// Request body
const requestData = {
    "api_key":"e769294327655e0ca20970dd7dd1b400",
    "key_id":"U2FsdGVkX1+RrnShmu3vfqRQnHa/a1f5SmjyEsSLyfI=",
    "zipcode": "560038",
    "pid": ["3437926"]
};

// Function to fetch data from API
const fetchEcomData = async () => {
    try {
        console.log('Fetching data, please wait...');
        
        // Make a POST request to the API
        const response = await axios.post(API_ENDPOINT, requestData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Handle API response
        console.log('API Response:', response.data);
    } catch (error) {
        console.error('Error fetching data:', error.response ? 
        error.response.data : error.message);
    }
};

// Call the function
fetchEcomData();
`}
                          </code>
                        </pre>
                      </div>
                    )}
                  </div>
                </div>

                {/* Implementation Explanation */}
                <div className='border-l-4 border-purple-500 pl-4'>
                  <h2 className='step-number-heading mb-4'>
                    {activeLibrary === 'Curl'
                      ? 'Step 3: Explanation of the Code'
                      : 'Step 4: Explanation of the Code'}
                  </h2>
                  {activeLibrary === 'Python' && (
                    <ul className='space-y-4'>
                      {explanationStepsPython.map((step, index) => (
                        <li
                          key={index}
                          className='p-4 border border-gray-300 rounded-lg shadow-sm'
                        >
                          <h3 className='text-lg font-semibold text-blue-600'>
                            {step.title}
                          </h3>
                          <p className='text-gray-700'>{step.description}</p>
                        </li>
                      ))}
                    </ul>
                  )}

                  {activeLibrary === 'JavaScript' && (
                    <ul className='space-y-4'>
                      {explanationStepsJS.map((step, index) => (
                        <li
                          key={index}
                          className='p-4 border border-gray-300 rounded-lg shadow-sm'
                        >
                          <h3 className='text-lg font-semibold text-blue-600'>
                            {step.title}
                          </h3>
                          <p className='text-gray-700'>{step.description}</p>
                        </li>
                      ))}
                    </ul>
                  )}

                  {activeLibrary === 'Curl' && (
                    <ul className='space-y-4'>
                      {explanationStepsCurl.map((step, index) => (
                        <li
                          key={index}
                          className='p-4 border border-gray-300 rounded-lg shadow-sm'
                        >
                          <h3 className='text-lg font-semibold text-blue-600'>
                            {step.title}
                          </h3>
                          <p className='text-gray-700'>{step.description}</p>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* Response JSON */}
                <div className='overview-about-ecom-pages-api border-l-4 border-gray-500 pl-4 mt-4'>
                  <h2 className='mb-3'>
                    {activeLibrary === 'Curl'
                      ? 'Step 4: Expected Response'
                      : 'Step 5: Expected Response'}
                  </h2>
                  <div className='python-request'>
                    <pre
                      className='bg-gray-900 text-white p-4 rounded-md overflow-auto'
                      style={{
                        // maxWidth: '900px',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                      }}
                    >
                      <code
                        style={{
                          whiteSpace: 'pre',
                          overflowX: 'auto',
                          display: 'block',
                        }}
                      >
                        {`{
    "data": [
        {
            "Product url": "https://www.firstcry.com/figaro-baby/
            figaro-baby-massage-oil-400-ml/12162092/product-detail?
            sterm=&spos=1&sstock=1",
            "Image url": "https://cdn.fcglcdn.com/brainbees/images/
            products/583x720/12162092a.webp",
            "Product Rating": "4.4",
            "Total Rating": "7857 Ratings",
            "Product Name": "Figaro Baby Massage Oil - 400 ml",
            "Discounted Price": "419",
            "MRP": "699",
            "Description": "Key Feature Massaging a newborn baby helps 
            in controlling excess oil, and retaining moisture Improves 
            the skin barrier of a baby's delicate skin Moisture protection
            and balance Specifications Brand-Figaro Type- Baby Massage
            Oil Age- 0 to 24 Months Quantity - 400 ml Product Description
            Figaro Baby massage oil, with natural olive oil, is a quick-
            absorbing, paraben-free formula, specially designed to improve a
            baby's delicate skin barrier integrity and moisturization. Rub 
            the oil between your palms and massage the baby gently in large
            circular motions. Wrap your hands fully on your baby's body while
            massaging. Items included in the Pack 1 Pack of Baby Massage
            Oil Country of Origin: India The product expiry date 
            will be displayed only when the pincode is entered.
            Manufacturing, Import, Packaging and Customer Care Information
            Note : Mix of Taxes and discount may change depending the amount of
            tax being borne by the Company. However, the final price as charged
            from customer will remain same. Taxes collected against every 
            transaction will be paid to the Government by Firstcry.com. 
            Please refer to the Terms of Use for full details.Product 
            ID: 12162092",
            "Key Features": null,
            "Country of Origin": "India",
            "Included in the Package": null,
            "Product Description": "Figaro Baby massage oil, with natural olive
            oil, is a quick-absorbing, paraben-free formula, specially designed
            to improve a baby's delicate skin barrier integrity and moisturization.
            Rub the oil between your palms and massage the baby gently in large 
            circular motions. Wrap your hands fully on your baby's body while
            massaging."
        }
    ]
}`}
                      </code>
                    </pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(FirstCryEcom);
